import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concatByComma'
})
export class ConcatByCommaPipe implements PipeTransform {

  transform(value: unknown, ...args: string[]): string {
    if (value == null) {
      return '';
    }

    if (typeof value === 'string' || typeof value === 'number') {
      return String(value);
    }

    if (!Array.isArray(value)) {
      return String(value);
    }

    const propriedadeItem = args[0];
    const itensFormatados = value.map((item) => {
      if (typeof item === 'string' || typeof item === 'number') {
        return ' ' + item;
      }
      return ' ' + (item as Record<string, unknown>)?.[propriedadeItem];
    });

    const stringComVirgula = itensFormatados.length > 0 ? itensFormatados.toString() : '---';

    return stringComVirgula;
  }

}
